import type { DocumentModel } from "@/models/DocumentModel";

export function preserveMathCursorPosition(
  doc: DocumentModel,
  cb: () => void,
  predicate: () => boolean = () => true,
) {
  const {
    editor: { tiptap },
  } = doc;

  if (!tiptap) {
    return;
  }

  if (doc.cursor.isActive && predicate()) {
    const { node: originalNode, index: originalIndex } = doc.cursor;
    cb();
    doc.cursor.reset();
    queueMicrotask(() => {
      doc.cursor.moveTo(originalNode, originalIndex);
    });
  } else {
    tiptap.commands.focus();
    cb();
  }
}
